/**
 * Which clicks the generic click logger in View.tsx keeps out of the activity log.
 *
 * That logger writes `User clicked on "<button text>" button` for every button a
 * guest or operator touches, and the session activity log is uploaded to the
 * Studio, where anyone with dashboard access can read it. On a keypad the button
 * text IS the secret: the operator PIN prompt used to log one entry per digit, so
 * the PIN could be read straight off a session's log.
 *
 * Two markers silence a subtree:
 * - `data-operator-area`: the operator settings panel, kept out as noise.
 * - `data-no-log`: anything whose button labels must never be stored, like the PIN
 *   keypad. Log the outcome instead (`Payment skipped by operator`), never the keys.
 */
const SILENT_SUBTREE = '[data-operator-area], [data-no-log]'

/** True when a click on `target` must not be written to the activity log. */
export const isClickLogSuppressed = (target: { closest(selectors: string): unknown }): boolean =>
  target.closest(SILENT_SUBTREE) !== null
